import { BookOpen, FilePlus, FileText } from '@lucide/vue';
import type { NavSpec } from './nav';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

// The report designer's navbar and command-palette entries. Its routes come from
// the designer's own app module (frontend/designer/src/connect, I-1786); these
// stay in the shell so the palette offers them before the designer is loaded.

/**
 * The designer's navbar contribution — lifted out of its ShellLayout header so
 * the Connect shell owns the navbar (consistent with erp/mail/…). Mirrors the
 * two top-level destinations the standalone designer exposed.
 */
export const designerNav: NavSpec = {
  left: [
    {
      id: 'designer.reports',
      text: 'reports.title',
      icon: FileText,
      to: '/designer',
      requiredPermissions: 'reports.view',
    },
    {
      id: 'designer.help',
      text: 'help.menu',
      icon: BookOpen,
      to: '/designer/help',
      requiredPermissions: 'reports.view',
    },
  ],
};

/**
 * designer's command-palette contribution — its two top-level destinations,
 * injected into the shell registry via its AppEntry (the shell auto-adds the
 * plain "open Designer" command separately).
 */
export const designerCommands: CommandFactory = ({ router, t, can, appLabel: designer }) => {
  // The same check as the reports list's „Neuer Bericht“ button.
  const canManage = !can || can(['reports.view', 'reports.manage'], 'all');
  return [
    ...(canManage
      ? [
          // I-2348: the reports list opens its template picker for `?new=report`.
          appLocationCommand(router, {
            id: 'designer.newReport',
            app: 'designer',
            group: designer,
            label: `${designer}: ${t('reports.new')}`,
            href: '/designer?new=report',
            icon: FilePlus,
            keywords: ['report', 'bericht', 'beleg', 'vorlage', 'neu', 'new'],
          }),
        ]
      : []),
    {
      id: 'designer.reports',
      label: `${designer}: ${t('reports.title')}`,
      group: designer,
      icon: FileText,
      keywords: ['reports', 'berichte', 'designer', 'belege'],
      run: () => {
        void router.push('/designer');
      },
    },
    {
      id: 'designer.help',
      label: `${designer}: ${t('help.menu')}`,
      group: designer,
      icon: BookOpen,
      keywords: ['help', 'hilfe', 'designer'],
      run: () => {
        void router.push('/designer/help');
      },
    },
  ];
};

